<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">权限管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleRuleCreate"
          >添加一级权限</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <el-table
        :data="rules"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          prop="title"
          label="名称"
          min-width="160"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="编码"
          min-width="200"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="160"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{scope.row.remark || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{scope.row.type == 1 ? '页面' : '其它'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '禁用'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          min-width="180"
          align="center"
        >
          <template slot-scope="scope">{{$moment(scope.row.create_time).format('YYYY/MM/DD HH:mm:SS')}}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
          v-if="isfixed"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleToRuleEdit(scope.row, scope.$index)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="text"
              v-if="scope.row.type == 1"
              @click="handleToRuleAdd(scope.row, scope.$index)"
            >添加子权限</el-button>
            <el-button
              size="mini"
              style="color:#f56c6c"
              type="text"
              @click="handleToRuleDelete(scope.row, scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="40"
          align="center"
          fixed="right"
          v-else
        >
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                ...
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  command="a"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleToRuleEdit(scope.row, scope.$index)"
                    style="font-size:16px;color: #409EFF;"
                  >
                    编辑
                  </span></el-dropdown-item>
                <el-dropdown-item
                  command="b"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleToRuleAdd(scope.row, scope.$index)"
                    style="font-size:16px;color: #409EFF;"
                  >
                    添加子权限
                  </span></el-dropdown-item>
                <el-dropdown-item
                  command="d"
                  style="margin-bottom:6px;"
                ><span
                    @click="handleToRuleDelete(scope.row, scope.$index)"
                    style="font-size:16px;color: #F56C6C;"
                  >
                    删除
                  </span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <RuleCreate
      :visible="createDialog"
      :content="addRow"
      @close="createDialog=false"
      @submit="fetchAdminRuleList"
    ></RuleCreate>
    <RuleEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog=false"
      @submit="fetchAdminRuleList"
    ></RuleEdit>
  </div>
</template>
<script>
import { adminRuleList, adminRuleDestroy } from "@/api/admin";
import RuleCreate from "@/components/dialog/admin/RuleCreate";
import RuleEdit from "@/components/dialog/admin/RuleEdit";

export default {
  components: {
    RuleCreate,
    RuleEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      query: {
        isPaging: 0,
      },
      rules: [],
      editRow: {},
      addRow: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.fetchAdminRuleList();
  },
  methods: {
    // 权限列表
    fetchAdminRuleList() {
      adminRuleList(this.query).then((res) => {
        this.rules = res.list || [];
        this.pageTotal = res.count || 0;
      });
    },
    // 权限创建
    handleRuleCreate() {
      this.createDialog = true;
    },
    // 权限编辑
    handleToRuleEdit(row, $index) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      if (row.pid) {
        this.editRow.parent = this.findRuleInfo(row.pid)
      }
      this.editDialog = true;
    },
    // 子权限创建
    handleToRuleAdd(item, $index) {
      this.addRow = item;
      this.createDialog = true;
    },
    // 权限删除
    handleToRuleDelete(item, index) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        adminRuleDestroy({ id: item.id }).then((res) => {
          this.$message.success(`删除成功`)
          this.fetchAdminRuleList()
        })
      }).catch(() => { })
    },
    // 获取权限详情
    findRuleInfo(id, rules) {
      let rule = null;
      (rules || this.rules).some(item => {
        if (item.id == id) {
          rule = item
          return true
        }
        if (item.children) {
          rule = this.findRuleInfo(id, item.children)
          if (rule) {
            return true
          }
        }
      })
      return rule
    }
  },
};
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>

